import info from "../assets/info-icon.png";
import React, {useState} from "react";


const InfoRightPopUp = (props) => {

    const [showHover, setShowHover] = useState(false);
    const text = props.text;

    return (
        <div className="info-popup-wrapper">
            <img className="info-popup-image" src={info} alt="Info"
                 onMouseOver={() => setShowHover(true)}
                 onMouseLeave={() => setShowHover(false)}
            />
            {showHover ?
                <div className="title-description-popup-container">
                    <div className="page-title-hover-triangle-outer">
                        <div className="page-title-hover-triangle-inner"/>
                    </div>
                    <div className="title-description-popup-text">
                        {text}
                    </div>
                </div>
                :null}
        </div>
    )
}

export default InfoRightPopUp